import { AbstractControl, ValidatorFn } from '@angular/forms';
import { FormsUtils } from '../../shared/forms.utils';
// @dynamic
export class CustomInputNumberValidator {
    static validateNumber(field: any): ValidatorFn {
        const validationData = field.validation.data.split(':');
        return (control: AbstractControl): { [key: string]: any } | null => {
            if (control.value) {
                const controlValue = control.value;

                if (!FormsUtils.isNumeric(controlValue)) {
                    return { number: { valid: false, messageKey: 'invalidNumber' } };
                }
                if (validationData) {
                    const actualNumber = parseFloat(controlValue);

                    const _minLength = parseInt(validationData[0]);
                    const _maxLength = parseInt(validationData[1]);
                    const shouldBeValidated = validationData.length > 2 && 'false' === validationData[2] ? !1 : !0;

                    if (shouldBeValidated && null !== _minLength && null !== _maxLength) {
                        if (actualNumber > _maxLength) {
                            return { number: { valid: false, messageKey: 'invalidNumberRangeTooLarge', max: _maxLength  } };
                        }
                        if (_minLength > actualNumber) {
                            return { number: { valid: false, messageKey: 'invalidNumberRangeTooSmall', min: _minLength  } };
                        }
                    }
                }
            }
            return null;
        };
    }

    static maxLength(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {
            if (control.value) {
                const trimmedValue =
                    FormsUtils.isNumeric(control.value) || control.value ? control.value : FormsUtils.trim(control.value);
                if (trimmedValue.length > 1e5) {
                    return { maxLength: { valid: false, messageKey: 'inputTooLarge' } };
                }
            }
            return { maxLength: { valid: true } };
        };
    }
}

// return { number: 'invalidNumberRangeTooSmall' };
// return { number: 'invalidNumberRangeTooLarge' };
// return { number: 'numberOutOfRange' };
